import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  SimpleChanges,
} from "@angular/core";
import { MobileDetectionService } from "../../services/mobile-detection.service";
import { MenuItem } from "primeng/components/common/menuitem";
import { TranslateService } from "@ngx-translate/core";
import { TranslateConfigService } from "../../../theme/home/translateConfig.service";
import { IDropdownField } from "../dropdown-field-box/model/IDropdown";
import { environment } from "../../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { appService } from "../../../_services/app.service";
import { ToastrService } from "ngx-toastr";
const LNG_KEY = "SELECTED_LANGUAGE";

interface DropdownCategory {
  label: any;
  subOptions: { icon: any; label: any; value: any }[];
}
@Component({
  selector: "app-page-header",
  templateUrl: "./page-header.component.html",
  styleUrls: ["./page-header.component.scss"],
})
export class PageHeaderComponent {
  isMobileView: any = false;
  //add by maaria
  //inFilteredState: any = false;
  //end
  @Input() items: MenuItem[];
  isFilterShow: boolean;
  // isFilterApplyed: boolean;
  searchFieldDetails: any = {
    placeholder: "Search",
    type: "text",
    isSearchBox: true,
  };

  @Output() gobackbytitle = new EventEmitter<string>();
  @Input() redirectTo: string = "/index2";

  @Input() isDetailsPageShow: boolean = false;
  @Input() totalCount: number;
  @Input() totalWeight: any;
  @Input() totalCBM: any = 0;
  @Input() VehicleType: any;
  @Input() isMoreActionBtn: boolean;
  @Input() onlyActionBtn: boolean;
  @Input() isShowSuggestion: boolean;
  @Input() title: string;
  @Input() isFilter: boolean;
  //ADDED BY RAHUL
  @Input() IsMapShow: boolean;
  //END
  @Input() listOfFilter: any[] = [];
  @Output() goToTable = new EventEmitter<string>();
  @Output() addBtnClick = new EventEmitter<boolean>();
  @Output() seachValueOutput = new EventEmitter<string>();
  @Output() seachddValueOutput = new EventEmitter<string>();
  @Output() seachShipNowOutput = new EventEmitter<string>();
  @Output() onFilterClickOutput = new EventEmitter();
  @Output() onFilterClickApplyOutput = new EventEmitter<any[]>();
  @Output() onViewTypeOutput = new EventEmitter<any>();
  @Output() onClickMapOutput = new EventEmitter<any>();
  @Output() onFilterSearchOutput = new EventEmitter<IDropdownField>();
  @Output() searchKeyword = new EventEmitter<IDropdownField>();
  @Input() isSearch: boolean = true;
  @Input() isViewTypeBox: boolean = true;
  @Input() isVisualizerShow: boolean = false;
  @Input() isCardShow: boolean = true;
  @Input() isButton: boolean = true;
  @Input() isDropdown: boolean = false;
  @Input() isDD: boolean = false;
  @Input() isDependDD: boolean = false;
  @Input() dropdownFieldDetails: any = {};
  @Input() ShipNowddDetail: any = {};
  @Input() ddDependFieldDetails: any = {};
  @Input() selectedDropdownValue: any;
  @Input() selectedDdDependValue: any;
  selectedLang: any;
  @Input() isShowCount: boolean = true;
  @Input() isTotalWeight: boolean = false;
  @Input() isTotalCBM: boolean = false;
  @Input() isShowVehicleType: boolean = false;
  @Input() isBeatshow: boolean = false;
  @Input() isDateField: boolean = false;
  @Input() dateFieldDetails: any = {};
  @Input() selectedDateValue: any;
  @Input() isActionBtn: boolean = false;
  @Input() isActionBtnOnly: boolean = false;
  @Input() isFrame: boolean = false;
  @Input() isshareshow: boolean = false;
  @Input() isshowrefresh: boolean = false;
  @Input() isshowoptions: boolean = false;
  @Input() isshowclose: boolean = false;
  @Input() isshowfilter: boolean = false;
  @Input() isshowsearchbar: boolean = false;
  @Input() isAttachment: boolean = false;
  @Input() isattachedfilter: boolean = false;
  @Input() isAttachmentupload: boolean = false;
  @Input() isAttachmentDownload: boolean = false;
  @Input() islatestfilter: boolean = false;
  @Input() isAttachmentdocs: boolean = false;
  @Input() isSearchnewupd: boolean = false;
  @Input() isattachedfilterftl: boolean = false;
  @Input() ispagedownload: boolean = false;
  @Input() isApply: boolean = false;
  @Input() ispageprint: boolean = false;
  @Input() isupload: boolean = false;
  @Input() isSetting: boolean = false; // Added by priya - 27/05/2026 - cn(PRIYA-MAY26-010)
  @Input() isftllisthead: boolean = false;
  @Input() VehicleStatusCount: any = {
    TotalVehicles: 0,
    RunningVehicles: 0,
    IdleVehicles: 0,
    StoppedVehicles: 0,
    InactiveVehicles: 0,
    NodataVehicles: 0,
  };
  @Input() isReload: boolean = false;
  @Input() isMoreData: boolean = false;
  @Input() isCancel: boolean = false;
  // @Input() isFrame: boolean = false;
  @Input() isBeat: boolean = false;
  @Input() isNewdiscard: boolean = false;
  @Input() isNewTyreDiscard: boolean = false;
  @Input() isNewdiscardReturn: boolean = false;
  @Input() isTyreRepairDrop: boolean = false;
  @Input() IsTyresActionShow: boolean = false;
  @Input() IsDashboardShow: boolean = false;
  @Input() hideBackArrow: boolean = false;
  @Input() IsShipNowDropdown: boolean = false;
  @Input() isBidSettingShow: boolean = false;
  @Input() isCloseBidShow: boolean = false;
  @Input() isSendBidRequest: boolean = false;
  @Input() isVehicleRequest: boolean = false;
  @Input() ShipNowDD: boolean = false;
  @Output() cancelClicked = new EventEmitter<void>();
  @Input() isSharedBidShow: boolean = false;
  @Input() isFtlShipnow: boolean = false;
  @Input() tabRoutes: { label: string; route: string }[] = [];
  @Input() selectedSearchValue: any = "";
  @Input() selectedDataCountShow: any = "";
  @Input() buttonLabel: any = "";
  @Input() dropdownItems: { icon: any; label: any; value: any }[] = [];
 @Output() optionSelected = new EventEmitter<{ category: any, value: any }>();
  @Input() isCommanDropDown: boolean = false;
  @Input() dropdownLeft: boolean = false;
  showDropdown = false;
  expandedCategoryIndex: number | null = null;
  @Input() categories: DropdownCategory[] = [];
  Beat: string = "Beats";
  TyreRepair: any;
  viewType: string = "table";
  @Output() onFilterBoxClick = new EventEmitter();
  @Output() onRefreshClick = new EventEmitter<string>();
  isBestUrl: any =
    environment.apiUrl == "https://best.ifreightbox.net/" ? true : false;
  checkedValue: any = "Vehicle";
  @Output() OnCheckRadio = new EventEmitter<string>();
  @Output() onDownloadClickOutput = new EventEmitter();
  @Output() onApplyClickOutput = new EventEmitter();
  @Output() onPrintClickOutput = new EventEmitter();
  @Output() onUploadClickOutput = new EventEmitter();
  @Output() onSettingClickOutput = new EventEmitter(); // Added by priya - 27/05/2026 - cn(PRIYA-MAY26-010)
  @Output() onSuggestionClickOutput = new EventEmitter();
  @Output() NewBtnClickOutput = new EventEmitter();
  @Input() NewBtnName: any = [];
  @Input() IsNewBtn: boolean = false;
  ShipNowData: any;
  @Input() shareActionList: any = [];
  @Output() onShareClick = new EventEmitter();
  @Output() onBidSettingeClick = new EventEmitter();
  @Output() onSendVehicleRequest = new EventEmitter();
  @Output() onCloseBid = new EventEmitter();
  @Input() IsCustomNewBtn: boolean = false;
  @Input() IsPostBtn: boolean = false;
  @Input() CustomNwBtnName: any = [];
  @Input() isBidClosed: boolean = false;
  @Input() isCancelMob: boolean = false;
  //added by vithu 19-03-2025
  @Output() addCustomBtnClick = new EventEmitter<boolean>();
  @Input() isnewWorkflow: boolean = false;
  @Input() isKabanShow: boolean = false;
  @Input() isShowHomeButtonForMobile: boolean = false;
  @Input() isHeaderOptions: boolean = false;
  @Input() isHeaderOptionOpen: boolean;
  @Input() HeaderOptions: { name: string, link?: string }[] = [];

  @Output() HeaderOptionsToggle = new EventEmitter();
  @Output() isHeaderOptionOpenChange = new EventEmitter<boolean>();
  @Output() onHeaderItemClick = new EventEmitter<{ name: string, link?: string }>();
  @Input() isFilterApplyed: boolean = false;

  @Input() isBidRequestFilter: boolean = false; //added by fahim 30-1-2026
  @Output() BidRequestFilterValue = new EventEmitter(); // added by fahim 30-01-2026
  @Input() isShowCreateTrip: boolean = false; //added by fahim 03-02-2026
  
  @Input() IsFilterItems: boolean = false; // added by priya - 06/02/2026 - cn(PRIYA-JAN26-017)
  @Input() FilterItems: { label: string, value: string }[] = []; // added by priya - 06/02/2026 - cn(PRIYA-JAN26-017)
  @Output() FilterValue = new EventEmitter(); // added by priya - 06/02/2026 - cn(PRIYA-JAN26-017)
  @Input() isDMRUploadInstructions: boolean = false; //added by fahim 12-02-2026
  @Input() isDMROptionOpen: boolean;  //added by fahim 12-02-2026
  @Input() isCancelButtonVisible: boolean=false;  //added by fahim 06-03-2026
  @Output() XClicked = new EventEmitter<void>();
  @Input() isWarehouseDropdownShow: boolean=false;  //added by fahim 06-03-2026
  @Input() showExpandCollapse: boolean = false; //added by BURHAN - 17-June-2026
  @Output() onExpandAll = new EventEmitter<void>(); //added by BURHAN - 17-June-2026
  @Output() onCollapseAll = new EventEmitter<void>(); //added by BURHAN - 17-June-2026
  @Input() isDashboardActive: boolean = false; // added by yash 11=07-2026

   WarehouseDropdown: any = {
      // lable: "Warehouse",
      placeholder: "selcet warehouse",
      dataField: 'WarehouseDetail',
      formControlName: 'WarehouseDetail',
      isRequired: false,
      isSearchByApi: true,
      typeOfField: 'dropdown',
      isValueBind: true
  };
  userId: any;
  WarehouseValue: any;
  CompanyId: any; //added by BURHAN - 27-June-2026
  @Output() sendWHvalue = new EventEmitter<void>();

  //added by fahim 17-04-2026 :)
  @Input() isTotalConfirmAmount: boolean = false; 
  @Input() isTotalPendingAmount: boolean = false;
  @Input() isTotalCancelledAmount: boolean = false;
  @Input() isTotalAllocatedAmount: boolean = false;
  @Input() TotalConfirmAmount: any = 0;
  @Input() TotalPendingAmount: any = 0;
  @Input() TotalCancelledAmount: any = 0;
  @Input() TotalAllocatedAmount: any = 0;
  //End by fahim 17-04-2026 :)

  HideMfgExpDateOnInward: boolean = false;
  @Input() isShowHideMfgExpDateOnInward: boolean = false;
  @Input() IsOrderSummaryShow: boolean=false;
  @Input() IsWaveOrderSummaryShow: boolean=false;

  constructor(
    private mobileDetectionService: MobileDetectionService,
    private translate: TranslateService,
    private service: TranslateConfigService,
    private router: Router,
    private route: ActivatedRoute,
    private _appService: appService,
    private toastr: ToastrService,
  ) {
    // let language = this.translate.getBrowserLang();
    // let value = localStorage.getItem(LNG_KEY);
    // if (value === "" || value === null || value === undefined) {
    //   this.translate.setDefaultLang(language);
    //   this.selectedLang = language;
    // } else {
    //   this.service.setLanguage(value);
    //   this.selectedLang = value;
    // }
    // let val = localStorage.getItem(LNG_KEY);
  }
  ngOnInit() {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.searchFieldDetails.value = this.selectedSearchValue || ''; //added by BURHAN - 1-July-2026
    this.intializeform();
    this.LoadEnableMfgExpDateOnInward();
    console.log(
      "selectedSearchValue from pageheader:",
      this.selectedSearchValue
    );
    // Added by priya - displayed by default 1st label selected - cn(PRIYA-JAN26-017)
    if (this.FilterItems.length) {
      this.selectedFilter = this.FilterItems[0].value;
    }
  }

  //added by BURHAN - 1-July-2026
  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedSearchValue']) {
      this.searchFieldDetails.value = this.selectedSearchValue; // sync to input
    }
  }
  //end by BURHAN - 1-July-2026

  intializeform() {
    this.TyreRepair = {
      formControlName: "TyreRepair",
      dataField: "TyreRepair",
      isRequired: false,
      type: "email",
      placeholder: "All",
    };
    // this.ShipNowData = {
    //   formControlName: 'ShipNowData',
    //   dataField: 'ShipNowData',
    //   placeholder: 'select here',
    // };
  }

  save(severity: string) { }

  @HostListener("window:resize", ["$event"])
  onResize(event: Event) {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
  }

  update() { }

  delete() { }

  onBackArrowCLick() {
    this.goToTable.emit();
  }

  gobackbytitlefn() {
    this.gobackbytitle.emit();
  }

  onAddClick() {
    this.addBtnClick.emit();
  } 

  onCustomAddClick() {
    this.addCustomBtnClick.emit();
  }

  onSearch(value: any) {
    this.seachValueOutput.emit(value);
  }

  getddDependValue(value: any) {
    this.seachddValueOutput.emit(value);
  }

  getShipNowValue(value: any) {
    this.seachShipNowOutput.emit(value);
  }

  getDdDependValue(value: any) {
    this.selectedDdDependValue.emit(value);
  }

  onddDependSearch = (event: string): void => {
    console.log("Search Keyword:", event);
    this.ddDependFieldDetails.searchKeyword = event;
    this.searchKeyword.emit(this.ddDependFieldDetails);
  };

  onShipNowSearch = (event: string): void => {
    console.log("Search Keyword:", event);
    this.ShipNowddDetail.searchKeyword = event;
    this.searchKeyword.emit(this.ShipNowddDetail);
  };
  onFilterClick(value) {
    this.isFilterShow = value;
    //add by maaria
    // var filterListContainsData = this.listOfFilter.some(value => value !== '' && value !== undefined && value !== null);
    // filterListContainsData ? this.inFilteredState = true : this.inFilteredState = false;
    //end
    if (value) {
      this.onFilterClickOutput.emit();
    }
  }

  onFilterApply(filterList: any[], isFilterApplyed) {
    this.onFilterClickApplyOutput.emit(filterList);
    this.isFilterApplyed = isFilterApplyed;
  }

  onViewtypeChange(type) {
    this.viewType = type;
    this.onViewTypeOutput.emit(type);
  }

  onClickMap() {
    this.onClickMapOutput.emit();
  }

  onFilterSearch = (event: IDropdownField): void => {
    this.onFilterSearchOutput.emit(event);
  };

  handleHeaderToggle() {
    this.isHeaderOptionOpen = !this.isHeaderOptionOpen;
    this.isHeaderOptionOpenChange.emit(this.isHeaderOptionOpen);

  }

  handleItemClick(item: { name: string, link?: string }, event: Event) {
    event.stopPropagation(); // prevent toggle from firing
    this.onHeaderItemClick.emit(item);
  }

  onFilterbtnClick(filterType) {
    this.onFilterBoxClick.emit(filterType);
    if (!this.isMobileView) {
      document.getElementById("total").classList.remove("active-total");
      document.getElementById("running").classList.remove("active-running");
      document.getElementById("stopped").classList.remove("active-stopped");
      document.getElementById("inactive").classList.remove("active-inactive");
      document.getElementById("nodata").classList.remove("active-nodata");
      document.getElementById("idle").classList.remove("active-idle");

      if (filterType == "TotalVehicles") {
        document.getElementById("total").classList.add("active-total");
      } else if (filterType == "RunningVehicles") {
        document.getElementById("running").classList.add("active-running");
      } else if (filterType == "StoppedVehicles") {
        document.getElementById("stopped").classList.add("active-stopped");
      } else if (filterType == "InactiveVehicles") {
        document.getElementById("inactive").classList.add("active-inactive");
      } else if (filterType == "NodataVehicles") {
        document.getElementById("nodata").classList.add("active-nodata");
      } else if (filterType == "IdleVehicles") {
        document.getElementById("idle").classList.add("active-idle");
      }
    } else {
      document.getElementById("total1").classList.remove("active-total");
      document.getElementById("running1").classList.remove("active-running");
      document.getElementById("stopped1").classList.remove("active-stopped");
      document.getElementById("inactive1").classList.remove("active-inactive");
      document.getElementById("nodata1").classList.remove("active-nodata");
      document.getElementById("idle1").classList.remove("active-idle");

      if (filterType == "TotalVehicles") {
        document.getElementById("total1").classList.add("active-total");
      } else if (filterType == "RunningVehicles") {
        document.getElementById("running1").classList.add("active-running");
      } else if (filterType == "StoppedVehicles") {
        document.getElementById("stopped1").classList.add("active-stopped");
      } else if (filterType == "InactiveVehicles") {
        document.getElementById("inactive1").classList.add("active-inactive");
      } else if (filterType == "NodataVehicles") {
        document.getElementById("nodata1").classList.add("active-nodata");
      } else if (filterType == "IdleVehicles") {
        document.getElementById("idle1").classList.add("active-idle");
      }
    }
  }

  refreshClick() {
    this.onRefreshClick.emit();
  }

  RadiobtnClick(event) {
    this.checkedValue = event.target.value;
    this.OnCheckRadio.emit(event.target.value);
  }

  onDownloadClick() {
    this.onDownloadClickOutput.emit();
  }

  onApplyClick() {
    this.onApplyClickOutput.emit();
  }

  onPrintClick() {
    this.onPrintClickOutput.emit();
  }

  onUploadClick() {
    this.onUploadClickOutput.emit();
  }
  
  // Added by priya - 27/05/2026 - cn(PRIYA-MAY26-010)
  onSettingClick() {
    this.onSettingClickOutput.emit();
  }
  // End by priya 

  onSuggestionClick() {
    this.onSuggestionClickOutput.emit();
  }

  onNewBtnClick() {
    this.NewBtnClickOutput.emit();
  }

  onCancelClick() {
    this.cancelClicked.emit();
  }

  redirectToPage() {
    this.router.navigateByUrl(this.redirectTo);
  }

  onShowMenu = (): void => {
    const menuEl = document.querySelector("p-menu");
    if (menuEl) {
      setTimeout(() => {
        const div = menuEl.querySelector("div");
        div ? (div.style.left = "66%") : null;
      }, 100);
    }
  };

  onActionClick = ({ actionName }): void => {
    this.onShareClick.emit(actionName);
  };

  onTabChange(event: any) {
    console.log("event", event);
    const selectedTab = this.tabRoutes[event.index];
    if (selectedTab && selectedTab.route) {
      this.router.navigate([selectedTab.route]); // Navigate to the selected tab's route
    }
  }

  onSendVehicleMail() {
    this.onSendVehicleRequest.emit();
  }

  onBidSettingClick() {
    this.onBidSettingeClick.emit();
  }

  onCloseBidClick() {
    this.onCloseBid.emit();
  }

  
   toggleDropdown() {
    this.showDropdown = !this.showDropdown;
    this.expandedCategoryIndex = null;
  }

  
  toggleCategory(index: number) {
    this.expandedCategoryIndex = this.expandedCategoryIndex === index ? null : index;
  }

  selectOption(category: any, value: any) {
      this.optionSelected.emit({ category, value });
      this.showDropdown = false;
      this.expandedCategoryIndex = null;
    }
  // selectOption(value: any) {
  //   this.optionSelected.emit(value);
  //   this.showDropdown = false;
  // }

  //added by fahim 30-01-2026
  selectedFilter: string = 'Active'; 
  showFilterSheet = false;
  isClosing = false;
  statuses = ['Active', 'Won', 'Lost', 'Not Participate'];

  openStatusFilter() {
    this.showFilterSheet = true;
     this.isClosing = false;
  }

  closeFilterSheet() {
    this.isClosing = true;
    // this.showFilterSheet = false;
    setTimeout(() => {
      this.showFilterSheet = false;
      this.isClosing = false;
    }, 250); 
  }

  selectStatus(status: string) {
    this.selectedFilter = status;
    this.closeFilterSheet();
    this.onClickFilter(status);
  }

  onClickFilter(filter: string) {
    this.selectedFilter = filter;
    this.BidRequestFilterValue.emit(filter);
    // Added by priya - 06/02/2026 - cn(PRIYA-JAN26-017)
    this.FilterValue.emit(filter);
  }
  // end added by fahim 30-01-2026

  handleDMRToggle() {
    this.isDMROptionOpen = !this.isDMROptionOpen;
  }

  onClickCancel() {
    this.XClicked.emit();
  }

  GetWarehouseDropList (value, isScrollDown = false) {
    this.WarehouseDropdown.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.WarehouseDropdown.dropdownList.length / 20) + 1;
    }
    this._appService.GetByTwoId("so_GoodsOutward", "GetWarehouseList",value , this.CompanyId).subscribe(
      (res) => {
        let dropdownList = [...res];
        if (isScrollDown && res.Total > this.WarehouseDropdown.dropdownList.length) {
          dropdownList = dropdownList.concat(this.WarehouseDropdown.dropdownList);
          this.WarehouseDropdown = { ...this.WarehouseDropdown, dropdownList: [...dropdownList] };
        }
        !isScrollDown && (this.WarehouseDropdown = { ...this.WarehouseDropdown, dropdownList: [...dropdownList] });
        this.WarehouseDropdown.isSearch = false;
      },
      (err) =>{
        console.error('error while loading warehouse');
        this.WarehouseDropdown.isSearch = false;
      }
    );
  }

  getChangedValueForWH(value,Type){
    if(value){
      this.WarehouseValue=value.value;
    }else{
      this.WarehouseValue=null;
    }

    this.sendWHvalue.emit(this.WarehouseValue);
  }
  
  changeStatus(status: any) {
    this.HideMfgExpDateOnInward = status;
    this.UpdateSaveExpenseApprovalSetting();
  }

  UpdateSaveExpenseApprovalSetting() {
    var value = "";
    if (this.HideMfgExpDateOnInward === true) {
      value = "1";
    } else {
      value = "0";
    }

    this._appService
      .UpdateSystemSettingByNameAndValue(
        "OrdersByVehicle",
        "UpdateSystemSettingByName",
        value,
        "HideMfgExpDateOnInward",
      )
      .subscribe(
        (res) => {
          if (res[0].Message) {
            this.toastr.success(res[0].Message, "success");
          }
        },
        (err) => {
          this.toastr.error("Error while Changing Setting", "Error");
        },
      );
  }

  LoadEnableMfgExpDateOnInward() {
    this._appService
      .GetById("Common", "GetSystemSettingByName", "HideMfgExpDateOnInward")
      .subscribe(
        (response) => {
          if (response == "1") {
            this.HideMfgExpDateOnInward = true;
          } else {
            this.HideMfgExpDateOnInward = false;
          }
          console.log("HideMfgExpDateOnInward>>", this.HideMfgExpDateOnInward);
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error",
          );
        },
      );
  }
}
